import {useEffect, useState} from "react";
import {addNewAdvertiser, updateAdvertiser} from "../../API/api";
import {Box, Button, Modal, TextField} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const AddEditAdvertiser = ({data = null, openAdvertiserModal, setOpenAdvertiserModal}) => {
    const [name, setName] = useState('')
    const [video_price, setVideo_price] = useState(0)
    const [banner_price, setBanner_price] = useState(0)
    const [ticker_price, setTicker_price] = useState(0)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

   const create = async () => {
        try {
            let data2 = {}
            data2.name = name
            data2.video_price = video_price
            data2.banner_price = banner_price
            data2.ticker_price = ticker_price
            const result = await addNewAdvertiser(localStorage.getItem("access_token"), data2)
            if (result) {
                setOpenAdvertiserModal(false)
                setName('')
                setVideo_price(0)
                setBanner_price(0)
                setTicker_price(0)
            }
        } catch (error) {
            console.dir(error);
            throw new Error("Что-то не так с пост запросом");
        }

    }

    const update = async () => {
        try {
            let data2 = {}
            data2.name = name
            data2.video_price = video_price
            data2.banner_price = banner_price
            data2.ticker_price = ticker_price
            const result = await updateAdvertiser(localStorage.getItem("access_token"), data.id, data2)
            if (result) {
                setOpenAdvertiserModal(false)
                setName('')
                setVideo_price(0)
                setBanner_price(0)
                setTicker_price(0)
            }
        } catch (error) {
            console.dir(error);
            throw new Error("Что-то не так с пост запросом");
        }

    }

    useEffect(() => {
        if (data) {
            setName(data.name)
            setVideo_price(data.video_price)
            setBanner_price(data.banner_price)
            setTicker_price(data.ticker_price)
        }
        if (!data) {
            setName('')
            setVideo_price(0)
            setBanner_price(0)
            setTicker_price(0)
        }
    },[data])

        return (
        <Modal
            open={openAdvertiserModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="add-user-form">
                    <TextField
                        id="outlined-basic"
                        label="Название"
                        variant="outlined"
                        className="add-user-form_input"
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value);
                        }}
                    />
                    <TextField
                        id="outlined-basic"
                        label="Цена ролики (мин)"
                        variant="outlined"
                        className="add-user-form_input"
                        type={"number"}
                        value={video_price}
                        onChange={(e) => {
                            setVideo_price(Number(e.target.value));
                        }}
                    />
                    <TextField
                        id="outlined-basic"
                        label="Цена баннеры (день)"
                        variant="outlined"
                        className="add-user-form_input"
                        type={"number"}
                        value={banner_price}
                        onChange={(e) => {
                            setBanner_price(Number(e.target.value));
                        }}
                    />
                    <TextField
                        id="outlined-basic"
                        label="Цена бегшка (сим/день)"
                        variant="outlined"
                        className="add-user-form_input"
                        type={"number"}
                        value={ticker_price}
                        onChange={(e) => {
                            setTicker_price(Number(e.target.value));
                        }}
                    />
                    <div className="mp-brand-form-clips_btn">
                        {!data ? <Button variant="contained" onClick={() => create()}>Добавить рекламодателя</Button> :
                        <Button variant="contained" onClick={() => update()}>Обновить рекламодателя</Button>}
                    </div>
                    <div className="add-user-form_btnclose" onClick={() => setOpenAdvertiserModal(false)}><HighlightOffIcon /></div>
                </div>
            </Box>
        </Modal>
    )
}

export default AddEditAdvertiser;